module.exports = __webpack_public_path__ + "static/img/threeDiseases.1abae07.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/threeDiseases.png
// module id = gQGU
// module chunks = 6